import { useRef } from 'react';
import { Textarea } from '@/components/ui/textarea';
import DictationButton from './DictationButton';

export default function DictableTextarea({ value, defaultValue, onChange, onDictation, disabled, contesto, ...props }) {
  const textareaRef = useRef(null);

  const handleDictation = (updater) => {
    const current = textareaRef.current?.value || value || defaultValue || '';
    const newVal = typeof updater === 'function' ? updater(current) : updater;
    if (textareaRef.current) {
      textareaRef.current.value = newVal;
    }
    if (onDictation) {
      onDictation(updater);
    } else if (onChange) {
      onChange({ target: { value: newVal } });
    }
  };

  return (
    <div className="relative">
      <Textarea
        ref={textareaRef}
        value={value}
        defaultValue={defaultValue}
        onChange={onChange}
        disabled={disabled}
        {...props}
        className={`pr-9 ${props.className || ''}`}
      />
      {!disabled && (
        <div className="absolute top-1.5 right-1.5">
          <DictationButton onResult={handleDictation} contesto={contesto} />
        </div>
      )}
    </div>
  );
}
